import React, { FC } from 'react';
import { WarningCircle } from 'common/svg';
import { dateFormatter } from 'common/helpers/date.helper';
import { EMetricType, EMetricTypeLabel } from 'common/models/commonModel';
import { ITrackStoreWeeklyGrid } from 'entities/TrackStore/TrackStore.models';
import { getWeekDates, mapDailyMetrics } from 'entities/TrackStore/TrackStore.helper';

interface IComponentProps {
  weeklyGrid: ITrackStoreWeeklyGrid | null;
}

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 120px) repeat(7, 1fr)',
    gap: 4,
  },
  row: {
    display: 'contents',
  },
  col: {
    height: 24,
    borderRadius: 4,
  },
};

export const TrackStoreWeeklyGrid: FC<IComponentProps> = ({ weeklyGrid }) => {
  const dates = getWeekDates(weeklyGrid?.weekStart);
  const dailyMetrics = mapDailyMetrics(weeklyGrid?.days, weeklyGrid?.weekStart);

  const renderRow = (type: EMetricType) => {
    return (
      <div style={styles.row}>
        <div className="mr-4 flex flex-align-center">
          <span className="ff-regular fs-xxs ellipsis">{EMetricTypeLabel[type]}</span>
        </div>
        {dailyMetrics[type].map((item, index) => {
          return <div key={index} style={{ ...styles.col, background: item >= 100 ? '#5dca8b' : '#ff4e4e' }} />;
        })}
      </div>
    );
  };

  return (
    <div>
      <div className="mb-5 flex flex-align-center flex-justify-between">
        <span className="ff-medium fs-xxs">Weekly Data</span>
        <WarningCircle className="icon-gray" />
      </div>

      <div style={styles.grid}>
        <div style={styles.row}>
          <div />
          {dates.map((item) => {
            const dayOfWeek = dateFormatter(item.toISOString(), 'ddd');

            return (
              <div
                key={dayOfWeek}
                className="flex flex-align-center flex-justify-center ff-regular fs-xxs color-gray-1"
              >
                {dayOfWeek.slice(0, 1)}
              </div>
            );
          })}
        </div>

        {renderRow(EMetricType.Sales)}
        {renderRow(EMetricType.TransactionCount)}
        {renderRow(EMetricType.AverageCheck)}

        <div style={styles.row}>
          <div className="mr-3 flex flex-align-center">
            <span className="ff-regular fs-xxs ellipsis">{EMetricTypeLabel[EMetricType.MaxQueuePerHour]}</span>
          </div>
          {dailyMetrics[EMetricType.MaxQueuePerHour].map((item, index) => {
            return (
              <div
                key={index}
                style={styles.col}
                className="flex flex-align-center flex-justify-center ff-regular fs-xxs color-gray-1"
              >
                {item}
              </div>
            );
          })}
        </div>

        <div style={styles.row}>
          <div className="mr-3 flex flex-align-center">
            <span className="ff-regular fs-xxs ellipsis">{EMetricTypeLabel[EMetricType.ServedOnTime]}</span>
          </div>
          {dailyMetrics[EMetricType.ServedOnTime].map((item, index) => {
            return (
              <div
                key={index}
                style={styles.col}
                className="flex flex-align-center flex-justify-center ff-regular fs-xxs color-gray-1"
              >
                {item}%
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
